








































import { postBannerItem, BannerItem, replaceBannerItem } from '@/api/banner';
import { UserModule } from '@/store/modules/user';
import { BASE_API } from '@/utils/request';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ElUpload } from 'element-ui/types/upload';

@Component({})
export default class BannerCreate extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private readonly bannerId!: string;

  @Prop({
    type: Object,
    required: false,
  })
  private readonly editItem?: BannerItem;

  private item: Omit<BannerItem, '_id' | 'imageURL'> = {
    imagePath: '',
    href: '',
    title: undefined,
    description: undefined,
  };

  private imageURL = '';

  private submitting = false;

  private readonly uploadURL = `${BASE_API}/upload`;

  private get uploadHeaders() {
    return {
      Authorization: UserModule.token,
    };
  }

  get rules() {
    const rules: Record<string, Array<object>> = {
      imagePath: [{ required: true, message: '请上传海报图片' }],
      href: [
        // { required: true, message: '请输入链接', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (
              value === undefined ||
              value === '' ||
              (typeof value === 'string' && value.match(/^(https?:\/\/)|\/|#/))
            ) {
              return callback();
            }
            return callback(new Error('链接格式不正确'));
          },
          trigger: 'blur',
        },
      ],
    };
    return rules;
  }

  @Watch('editItem', { immediate: true })
  private onEditItemChange(item?: BannerItem) {
    this.reset(item);
  }

  private reset(item?: BannerItem) {
    if (item) {
      this.item = {
        ...item,
      };
      this.imageURL = item.imageURL;
    } else {
      this.item = {
        imagePath: '',
        href: '',
        title: undefined,
        description: undefined,
      };
      this.imageURL = '';
    }
  }

  private handleUploadSuccess(file: { url: string; path: string; size: number }) {
    this.item.imagePath = file.path;
    this.imageURL = file.url;
  }

  private async submit() {
    const form = this.$refs.form as ElForm;
    const valid = await form.validate().catch((v) => v);
    if (valid) {
      const timeout = window.setTimeout(() => (this.submitting = true), 500);
      try {
        if (this.editItem) {
          await replaceBannerItem(this.bannerId, this.editItem._id, this.item);
        } else {
          await postBannerItem(this.bannerId, this.item);
        }
      } catch (e) {
        throw e;
      } finally {
        window.clearTimeout(timeout);
        this.submitting = false;
      }
      form.resetFields();
      (this.$refs.upload as null | ElUpload)?.clearFiles();
      this.imageURL = '';
      this.$emit('done');
    }
  }
}
